import styled from 'styled-components';

export const FormLine = styled.div`
    width: 100%;
    display: flex;
    column-gap: 1rem;
`;
